(function () {
  'use strict';

  function initCarousel(dotsEl) {
    var gridId = dotsEl.dataset.grid;
    var grid = document.getElementById(gridId);
    if (!grid || !window.IntersectionObserver) return;

    var cards = Array.from(grid.children);
    var dots  = Array.from(dotsEl.querySelectorAll('[data-slide]'));
    if (!cards.length || !dots.length) return;

    function setActive(idx) {
      dots.forEach(function (d) { d.removeAttribute('data-active'); });
      if (dots[idx]) dots[idx].setAttribute('data-active', '');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = cards.indexOf(entry.target);
          if (idx !== -1) setActive(idx);
        });
      },
      { root: grid, threshold: 0.5 }
    );

    cards.forEach(function (card) { observer.observe(card); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.slide, 10);
        if (!cards[idx]) return;
        cards[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-fg-dots]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
